export const endScriptsCamila = () => {
  const gtagManagerScript = document.getElementById("gtag-manager-script");
  const gtagScript = document.getElementById("gtag-script");
  const viCamilaScript = document.getElementById("vi-camila-script");

  if (gtagManagerScript) gtagManagerScript.remove();
  if (gtagScript) gtagScript.remove();
  if (viCamilaScript) viCamilaScript.remove();
  if (gtagManagerScript || gtagScript || viCamilaScript) window.location.reload();
}

export const hideCamila = () => {
  const camila = document.getElementById("eyeCatcherContent");
  if (camila) camila.style.visibility = "hidden";
}

export const showCamila = () => {
  const camila = document.getElementById("eyeCatcherContent");
  if (camila) camila.style.visibility = "visible";
}

export const openCamilaChat = () => {
  window?.VI_API?.openChat?.(1);
}